// extracted by mini-css-extract-plugin
export var mediaContainer = "styles-module--mediaContainer--b6a28";